import { render, staticRenderFns } from "./ScwlWaybillMonthChart.vue?vue&type=template&id=52d06845&scoped=true"
import script from "./ScwlWaybillMonthChart.vue?vue&type=script&lang=js"
export * from "./ScwlWaybillMonthChart.vue?vue&type=script&lang=js"
import style0 from "./ScwlWaybillMonthChart.vue?vue&type=style&index=0&id=52d06845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d06845",
  null
  
)

export default component.exports